
import { CALL_API, successResponse, notSuccessResponse } from '../../../util/api'

export const getLookupOrderGas = async () => {

    try {
        const response = await CALL_API.post('OrderGas/lookup');
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const setOrderGasVerify = async (param) => {

    try {
        const response = await CALL_API.post('OrderGas/verify', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}
export const setOrderGas = async (param) => {

    try {
        const response = await CALL_API.post('OrderGas/edit', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}
export const getOrderGasReport = async (param) => {

    try {
        const response = await CALL_API.post('Report/GasOrderReport', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const getGasReport = async (param) => {

    try {
        const response = await CALL_API.post('Report/GasReport', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const getGasList = async (param) => {

    try {
        const response = await CALL_API.post('OrderGas/List', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const setImportGasTransaction = async (param) => {

    try {
        const response = await CALL_API.post('OrderGas/import/gasTransaction', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const getGasTransaction = async (param) => {

    try {
        const response = await CALL_API.post('OrderGas/list/gasTransaction', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const updatePOSWashing = async (param) => {

    try {
        const response = await CALL_API.post('POS/Washing', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const getDashboardJobStatus = async (param) => {

    try {
        const response = await CALL_API.post('Dashboard/JobStatus', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const setWDFManualStatus = async (param) => {

    try {
        const response = await CALL_API.post('WashDryFold/manual/status', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const deleteWDFManualStatus = async (param) => {

    try {
        const response = await CALL_API.post('WashDryFold/delete/status', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const getWDFLocationList = async (param) => {

    try {
        const response = await CALL_API.post('WashDryFold/location/list', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const postWDFChangeLocation = async (param) => {

    try {
        const response = await CALL_API.post('WashDryFold/change/location', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const uploadfile = async (selectedFile) => {
    try {
        const formData = new FormData();
        formData.append('slip_image', selectedFile); // Assuming 'selectedFile' contains the file object

        const response = await CALL_API.post('File/upload/SLIP', formData);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
};

export const postWDFpaid = async (param) => {
    try {
        const response = await CALL_API.post('WashDryFold/paid', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
};


export const getCashlessList = async (param) => {

    try {
        const response = await CALL_API.post('Cashless/reconcile/list', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const updateStatusCashless = async (param) => {

    try {
        const response = await CALL_API.post('Cashless/reconcile/update/status', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const getCashlessReport = async (param) => {

    try {
        const response = await CALL_API.post('Cashless/reconcile/report', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}



export const getCashlessStatus = async () => {

    try {
        const response = await CALL_API.post('Cashless/reconcile/lookup/status');
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const getCashlessDiff = async () => {

    try {
        const response = await CALL_API.post('Cashless/reconcile/lookup/Diff');
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

//



export const getGasReorderDashboard = async (param) => {

    try {
        const response = await CALL_API.post('OrderGas/reorder-dashboard', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const setOrderGasStatusApi = async (param) => {

    try {
        const response = await CALL_API.post('OrderGas/status', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}
